import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'PublishVoohCampaignPayload'

export const PUBLISH_VOOH_CAMPAIGN = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation publishVoohCampaign($id: ID!) {
    publishVoohCampaign(input: { id: $id }) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
